let addLoadEvent = (func) => {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function() {
            if (oldonload) {
                oldonload();
            }
            func();
        }
    }
}

export default () => {
    addLoadEvent(function(){
        var lang = navigator.language || navigator.userLanguage;
        lang = lang === 'ru-RU' ? 'ru' : 'en';

        outdatedBrowser({
            bgColor: '#252628',
            color: '#ffffff',
            lowerThan: 'object-fit',
            languagePath: '/lang/' + lang + '.html'
        })
    });
}